import { Module } from 'vuex'

import { ModelAnswerPageStateModuleName } from '../modules'

import { GetSolutionWithRatingUseCase } from '@/application/modelAnswer/getSolutionWithRatingUseCase'
import { ModelAnswer } from '@/domain/entities/modelAnswer/modelAnswer'
import { ModelAnswerRepository } from '@/domain/repositories/modelAnswer/modelAnswerRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

interface ModelAnswerListState {
  modelAnswerList: { [judgeId: number]: ModelAnswer }
  loading: boolean
  error: Error | null
}

export const modelAnswerModule = (modelAnswerRepository: ModelAnswerRepository): Module<ModelAnswerListState, any> => {
  const getSolutionWithRatingUseCase = new GetSolutionWithRatingUseCase(modelAnswerRepository)

  return {
    namespaced: true,
    state: {
      modelAnswerList: {},
      loading: false,
      error: null
    },
    mutations: {
      setModelAnswerList(state, { list }: { list: { [judgeId: number]: ModelAnswer } }) {
        state.modelAnswerList = list
      },
      setModelAnswerListItem(state, { item }: { item: ModelAnswer }) {
        state.modelAnswerList[item.judgeId] = item
      },
      setLoading(state, loading: boolean) {
        state.loading = loading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchModelAnswerList(
        { state, commit },
        {
          problemId,
          programLanguage,
          pageIndex
        }: { problemId: string; programLanguage: ProgramLanguageType; pageIndex: number }
      ) {
        commit('setLoading', true)
        commit('setError', null)

        try {
          const data = await getSolutionWithRatingUseCase.getSolutionWithRatingUseCase(
            problemId,
            programLanguage,
            pageIndex
          )
          data.forEach(item => {
            commit('setModelAnswerListItem', { item })
          })
          if (data.length === 0) {
            commit(`${ModelAnswerPageStateModuleName}/setIsNotMoreModelAnswerList`, { flag: true }, { root: true })
          }
        } catch (error) {
          commit('setError', error)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      modelAnswerList: state => state.modelAnswerList,
      loading: state => state.loading,
      error: state => state.error
    }
  }
}
